import { Accordion, Alert, Col, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { ButtonContainer, StyledButton } from '../../StyledComponets';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import EnrollmentForm from '../EnrollmentForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { initialValues, validationSchema } from './helpers';
import { getProjectData } from '../../app/projects/createProjectSlice';
import { calculateProgramCapacity } from '../EnrollmentForm/helpers';

export default function CustomerProgram(props) {
  const { setSection, pageType } = props;

  const {
    register,
    watch,
    handleSubmit,
    trigger,
    setValue,
    reset,
    formState: { errors, isValid },
  } = useForm({
    reValidateMode: 'onChange',
    resolver: yupResolver(validationSchema),
    defaultValues: initialValues,
  });
  const isView = pageType === 'view';
  const isEdit = pageType === 'edit';
  const projectData = useSelector(getProjectData);
  const [isNextClick, setNextClick] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [pgmError, setPgmsError] = useState(false);
  const inValidList = programs.filter((el) => !el.isValid);

  const onAddProgram = () => {
    const uniqueID = () => Math.floor(Math.random() * Date.now());
    const id = uniqueID();
    setPrograms([...programs, { pgmId: id, data: [], isValid: false }]);
  };

  const onDeleteProgram = (pgmId) => {
    const newList = programs.filter((el) => el.pgmId !== pgmId);
    setPrograms(newList);
  };

  const updateProgram = (pgmId, updateObj) => {
    const pItem = programs.find((x) => x.pgmId === pgmId);
    const pIndex = programs.indexOf(pItem);
    if (pIndex >= 0) {
      const updateItem = {
        ...pItem,
        ...updateObj,
      };
      const newState = [...programs];
      newState[pIndex] = updateItem;
      setPrograms(newState);
    }
  };

  const validatePrograms = () => {
    if (inValidList.length === 0) {
      //Calling project API
      setNextClick(true);
      props.createOrSaveProject(programs, 'Save');
    } else {
      setPgmsError(true);
    }
  };

  useEffect(() => {
    if (projectData?.appNb && isNextClick) {
      setNextClick(false);
      setSection(true, programs);
    }
  }, [projectData]);

  useEffect(() => {
    if (inValidList.length === 0) {
      setPgmsError(false);
    }
  }, [inValidList.length]);

  useEffect(() => {
    if (props.formData?.data) {
      setPrograms(props.formData?.data);
    }
  }, [props.formData]);

  const programsValid =
    programs.filter((x) => x?.isValid).length === programs.length;
  return (
    <>
      {!isView && (
        <StyledButton
          btnType="primary"
          variant="dark"
          size="md"
          disabled={!programsValid}
          onClick={onAddProgram}
        >
          Add Program
        </StyledButton>
      )}
      {programs.length > 0 && (
        <>
          {pgmError && (
            <Alert variant={`danger`}>
              Error to procced next,please check all details & validate all
              programs
            </Alert>
          )}
          <Accordion>
            {programs.map((pgm, index) => (
              <Accordion.Item key={pgm.pgmId} eventKey={pgm.pgmId}>
                <Row>
                  <Col>
                    <Accordion.Header>
                      <></>
                      {`Program-${index + 1} `}{' '}
                      {!isView && (
                        <FontAwesomeIcon
                          style={
                            pgm.isValid
                              ? { color: 'green', paddingLeft: '10px' }
                              : { color: 'red', paddingLeft: '10px' }
                          }
                          icon={
                            pgm.isValid
                              ? ['fas', 'fa-circle-check']
                              : ['fas', 'fa-circle-exclamation']
                          }
                          size="md"
                        />
                      )}
                      <Form.Text size="sm" style={{ marginLeft: '10px' }}>
                        {calculateProgramCapacity(pgm)
                          ? ` (Total Program Capacity(kW):${calculateProgramCapacity(
                              pgm
                            ).toFixed(3)}`
                          : ''}
                      </Form.Text>
                    </Accordion.Header>
                  </Col>
                  {!isView && (
                    <Col xs={1} style={{ marginTop: '15px' }}>
                      <span onClick={() => onDeleteProgram(pgm.pgmId)}>
                        <FontAwesomeIcon
                          icon={['fas', 'trash-alt']}
                          size="md"
                        />
                      </span>
                    </Col>
                  )}
                </Row>
                <Accordion.Body>
                  <EnrollmentForm
                    key={pgm.pgmId}
                    pgmId={pgm.pgmId}
                    pageType={pageType}
                    updateProgram={updateProgram}
                    formData={props.formData}
                    program={pgm}
                  />
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
          {!isView && (
            <ButtonContainer>
              {!isEdit && (
                <StyledButton
                  btnType="secondary"
                  variant="dark"
                  size="md"
                  onClick={() => {
                    setSection(false);
                  }}
                >
                  Back
                </StyledButton>
              )}
              <StyledButton
                btnType="primary"
                variant="dark"
                size="md"
                onClick={validatePrograms}
              >
                {isEdit ? `Update` : `Save & Proceed`}
              </StyledButton>
            </ButtonContainer>
          )}
        </>
      )}
    </>
  );
}
